import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const PointsPage = lazy(() => import('./pages/PointsPage'));
const ReferralsPage = lazy(() => import('./pages/ReferralsPage'));
const TiersPage = lazy(() => import('./pages/TiersPage'));
const RewardsPage = lazy(() => import('./pages/RewardsPage'));

export const LoyaltyRoutes: RouteObject = {
  path: 'loyalty',
  element: <ModuleGuard moduleId="marketing.loyalty" />,
  handle: { crumb: 'Loyalty & Referral' },
  children: [
    { index: true, element: <Navigate to="points" replace /> },
    { path: 'points', element: <PointsPage />, handle: { crumb: 'Points' } },
    { path: 'referrals', element: <ReferralsPage />, handle: { crumb: 'Referrals' } },
    { path: 'tiers', element: <TiersPage />, handle: { crumb: 'Tiers' } },
    { path: 'rewards', element: <RewardsPage />, handle: { crumb: 'Rewards' } },
  ],
};
